import { ApplicationRoutes } from '../../../app-routes-names'

export const ReceivableRoutes = {
  shopsSummary: 'locations',
  receivablesList: 'receivables-list',
  arInvoicesSummary: 'ar',
  arMovingAverage: 'ar-moving-average',
  accountsSummary: 'accounts',
  arPaymentsSummary: 'ar-payments',
  snapshot: 'snapshot'
}

const { receivable } = ApplicationRoutes

export const ReceivablePaths = {
  shopsSummary: `/${receivable}/${ReceivableRoutes.shopsSummary}`,
  receivablesList: `/${receivable}/${ReceivableRoutes.receivablesList}`,
  arInvoicesSummary: `/${receivable}/${ReceivableRoutes.arInvoicesSummary}`,
  arMovingAverage: `/${receivable}/${ReceivableRoutes.arMovingAverage}`,
  accountsSummary: `/${receivable}/${ReceivableRoutes.accountsSummary}`,
  arPaymentsSummary: `/${receivable}/${ReceivableRoutes.arPaymentsSummary}`,
  snapshot: `/${receivable}/${ReceivableRoutes.snapshot}`
}
